// @ts-ignore
import {DateTime} from 'luxon';
import {ApiValidation} from "../../model/api/api-validation";
import {FieldResult} from "../../model/api/field-result";
import {TableRecordResult} from "../../model/api/table-record-result";
import {ReportProfile} from "../../model/archive/report-profile";
import {ApiFileResponse} from "../../model/api/api-file-response";
import {CrystalclearBackUrl} from "./crystalclear-back-url";
import {ReportTemplate} from "../../model/archive/report-template";
import {ReportTask} from "../../model/archive/report-task";
import {ReportTotalResidual} from "../../model/archive/report-total-residual";
import {ProfileTableRecordResult} from "../../model/archive/profile-table-record-result";
import {ProfileFieldResult} from "../../model/archive/profile-field-result";

export class CrystalclearArchiveBackUrl {
  //report
  static readonly GET_ARCHIVE_REPORT_PROFILE_LIST: CrystalclearBackUrl.UrlConf<ProfileTableRecordResult> = {
    url: '/api/archive/report-profiles/list',
    type: ProfileTableRecordResult
  };

  static readonly SAVE_ARCHIVE_REPORT_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<ReportProfile>> = {
    url: '/api/archive/report-profiles/save',
    type: ApiValidation
  };

  static readonly DELETE_ARCHIVE_REPORT_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/report-profiles/delete',
    type: ApiValidation
  };

  static readonly DOWNLOAD_ARCHIVE_REPORT_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/report-profiles/download-async',
    type: ApiValidation
  };

  static readonly DOWNLOAD_FORPROFILE_ARCHIVE_REPORT_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/report-profiles/downloadForProfile-async',
    type: ApiValidation
  };

  static readonly EXECUTE_ARCHIVE_REPORT_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string[]>> = {
    url: '/api/archive/report-profiles/execute-async',
    type: ApiValidation
  };

  static readonly GET_ARCHIVE_REPORT_PROFILE_EXPORT_TEMPLATES_FORM: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>> = {
    url: '/api/archive/report-profiles/exportTemplatesForm',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_REPORT_PROFILE_EXPORT_TEMPLATES_PROFILE: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>> = {
    url: '/api/archive/report-profiles/exportTemplatesProfile',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_REPORT_PROFILE_PROFILES_FIELDS_FORM: CrystalclearBackUrl.UrlConf<ProfileFieldResult> = {
    url: '/api/archive/report-profiles/profileFieldsForm',
    type: ProfileFieldResult
  };

  static readonly GET_ARCHIVE_REPORT_PROFILE_MAIL_TEMPLATES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/report-profiles/emailTemplates',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_REPORT_PROFILE_FILE_LOCATIONS: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/report-profiles/fileLocations',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_REPORT_PROFILE_TYPES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/report-profiles/profileTypes',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_REPORT_BATCH_UPDATE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/report-profiles/save-batch',
    type: ApiValidation
  };

  //recap
  static readonly GET_SYNC_PROFILES_WITH_EXPORTER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/recap-profiles/sync-profiles',
    type: ApiValidation
  };
  static readonly GET_SYNC_TEMPLATES_WITH_EXPORTER: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/recap-profiles/sync-templates',
    type: ApiValidation
  };
  static readonly GET_GENERATE_TEST_PROFILES_FROM_TEMPLATES: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/recap-profiles/generate-test-profiles-from-templates',
    type: ApiValidation
  };

  static readonly GET_ARCHIVE_RECAP_PROFILE_LIST: CrystalclearBackUrl.UrlConf<ProfileTableRecordResult> = {
    url: '/api/archive/recap-profiles/list',
    type: ProfileTableRecordResult
  };

  static readonly SAVE_ARCHIVE_RECAP_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<ReportProfile>> = {
    url: '/api/archive/recap-profiles/save',
    type: ApiValidation
  };

  static readonly DELETE_ARCHIVE_RECAP_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/recap-profiles/delete',
    type: ApiValidation
  };

  static readonly DOWNLOAD_ARCHIVE_RECAP_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/recap-profiles/download-async',
    type: ApiValidation
  };

  static readonly DOWNLOAD_FORPROFILE_ARCHIVE_RECAP_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/recap-profiles/downloadForProfile-async',
    type: ApiValidation
  };

  static readonly EXECUTE_ARCHIVE_RECAP_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string[]>> = {
    url: '/api/archive/recap-profiles/execute-async',
    type: ApiValidation
  };

  static readonly EXECUTE_DIFF_ARCHIVE_RECAP_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/recap-profiles/execute-diff-async',
    type: ApiValidation
  };

  static readonly GET_ARCHIVE_RECAP_PROFILE_EXPORT_TEMPLATES_FORM: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>> = {
    url: '/api/archive/recap-profiles/exportTemplatesForm',
    type: FieldResult
  };


  static readonly GET_ARCHIVE_RECAP_PROFILE_EXPORT_TEMPLATES_PROFILE: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>> = {
    url: '/api/archive/recap-profiles/exportTemplatesProfile',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_RECAP_PROFILE_PROFILES_FIELDS_FORM: CrystalclearBackUrl.UrlConf<ProfileFieldResult> = {
    url: '/api/archive/recap-profiles/profileFieldsForm',
    type: ProfileFieldResult
  };

  static readonly GET_ARCHIVE_RECAP_PROFILE_PROFILES_FIELDS_LIST: CrystalclearBackUrl.UrlConf<ProfileFieldResult> = {
    url: '/api/archive/recap-profiles/profileFieldsList',
    type: ProfileFieldResult
  };

  static readonly GET_ARCHIVE_RECAP_PROFILE_MAIL_TEMPLATES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/recap-profiles/emailTemplates',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_RECAP_PROFILE_FILE_LOCATIONS: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/recap-profiles/fileLocations',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_RECAP_BATCH_UPDATE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/recap-profiles/save-batch',
    type: ApiValidation
  };

  //INVOICE
  static readonly GET_ARCHIVE_INVOICE_PROFILE_LIST: CrystalclearBackUrl.UrlConf<ProfileTableRecordResult> = {
    url: '/api/archive/invoice-profiles/list',
    type: ProfileTableRecordResult
  };

  static readonly SAVE_ARCHIVE_INVOICE_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<ReportProfile>> = {
    url: '/api/archive/invoice-profiles/save',
    type: ApiValidation
  };

  static readonly DELETE_ARCHIVE_INVOICE_PROFILE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/invoice-profiles/delete',
    type: ApiValidation
  };

  static readonly DOWNLOAD_ARCHIVE_INVOICE_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/invoice-profiles/download-async',
    type: ApiValidation
  };

  static readonly DOWNLOAD_FORPROFILE_ARCHIVE_INVOICE_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string>> = {
    url: '/api/archive/invoice-profiles/downloadForProfile-async',
    type: ApiValidation
  };

  static readonly EXECUTE_ARCHIVE_INVOICE_PROFILE_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<string[]>> = {
    url: '/api/archive/invoice-profiles/execute-async',
    type: ApiValidation
  };

  static readonly GET_ARCHIVE_INVOICE_PROFILE_EXPORT_TEMPLATES_FORM: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>> = {
    url: '/api/archive/invoice-profiles/exportTemplatesForm',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_INVOICE_PROFILE_EXPORT_TEMPLATES_PROFILE: CrystalclearBackUrl.UrlConf<FieldResult<ReportTemplate>> = {
    url: '/api/archive/invoice-profiles/exportTemplatesProfile',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_INVOICE_PROFILE_PROFILES_FIELDS_FORM: CrystalclearBackUrl.UrlConf<ProfileFieldResult> = {
    url: '/api/archive/invoice-profiles/profileFieldsForm',
    type: ProfileFieldResult
  };

  static readonly GET_ARCHIVE_INVOICE_PROFILE_MAIL_TEMPLATES: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/invoice-profiles/emailTemplates',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_INVOICE_PROFILE_FILE_LOCATIONS: CrystalclearBackUrl.UrlConf<FieldResult<any>> = {
    url: '/api/archive/invoice-profiles/fileLocations',
    type: FieldResult
  };

  static readonly GET_ARCHIVE_INVOICE_BATCH_UPDATE: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/invoice-profiles/save-batch',
    type: ApiValidation
  };

  static readonly ARCHIVE_INVOICE_DOWNLOAD_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/invoice-profiles/download-invoice-async',
    type: ApiValidation
  };
  static readonly ARCHIVE_INVOICE_EMAIL_ASYNC: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/invoice-profiles/email-invoice-async',
    type: ApiValidation
  };

  //

  static readonly GET_ARCHIVE_TASK_CHECK: CrystalclearBackUrl.UrlConf<ApiValidation<ReportTask>> = {
    url: '/api/archive/report-tasks/check',
    type: ApiValidation
  };

  static readonly GET_ARCHIVE_TASK_DOWNLOAD: CrystalclearBackUrl.UrlConf<ApiFileResponse> = {
    url: '/api/archive/report-tasks/download',
    type: ApiFileResponse
  };

  static readonly GET_ARCHIVE_TASK_LIST: CrystalclearBackUrl.UrlConf<TableRecordResult<ReportTask>> = {
    url: '/api/archive/report-tasks/list',
    type: TableRecordResult
  };

  static readonly POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_LIST_FOR_DATE: CrystalclearBackUrl.UrlConf<ApiValidation<ReportTotalResidual[]>> = {
    url: '/api/archive/report-total-residual/get-for-date',
    type: ApiValidation
  };

  static readonly POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_ADJUST: CrystalclearBackUrl.UrlConf<ApiValidation<any>> = {
    url: '/api/archive/report-total-residual/adjust',
    type: ApiValidation
  };

  static readonly POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_ISDAILYREPORTENABLED: CrystalclearBackUrl.UrlConf<ApiValidation<boolean>> = {
    url: '/api/archive/report-total-residual/isDailyReportEnabled',
    type: ApiValidation
  };

  static readonly POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_ENABLEDAILYREPORT: CrystalclearBackUrl.UrlConf<ApiValidation<boolean>> = {
    url: '/api/archive/report-total-residual/enableDailyReport',
    type: ApiValidation
  };

  static readonly POST_ARCHIVE_REPORT_TOTAL_RESIDUAL_SENDREPORT: CrystalclearBackUrl.UrlConf<ApiValidation<string[]>> = {
    url: '/api/archive/report-total-residual/sendReport',
    type: ApiValidation
  };


}

